// src/pages/admin/AdminVolunteers.jsx
import React, { useEffect, useState } from "react";
import axiosInstance from "../../utils/axios";
import { FiUser, FiMail, FiPhone, FiMessageSquare, FiBriefcase, FiTarget, FiAward, FiLayers } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import {  MdDeleteOutline } from "react-icons/md";
import { toast } from "react-hot-toast";
import Pagination from "../../components/AdminSideComponents/AdminPagination";
import DeleteConfirmationModal from "../../components/AdminSideComponents/DeleteConfirmationModal";
import AdminSearchBar from "../../components/AdminSideComponents/AdminSearchBar";

// const SearchBar = ({ title, onSearch }) => {
//   const [searchQuery, setSearchQuery] = useState("");
//   const [debouncedQuery, setDebouncedQuery] = useState(searchQuery);

//   useEffect(() => {
//     const handler = setTimeout(
//       () => setDebouncedQuery(searchQuery.trim()),
//       500
//     );
//     return () => clearTimeout(handler);
//   }, [searchQuery]);

//   useEffect(() => {
//     onSearch(debouncedQuery);
//   }, [debouncedQuery]);

//   return (
//     <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4 py-4 px-4 sm:px-6 bg-gray-100 shadow-sm rounded-md mb-4">
//       <h1 className="text-xl sm:text-2xl font-bold text-primaryTextColor">
//         {title}
//       </h1>

//       <div className="flex items-center w-full md:w-auto">
//         <div className="relative flex grow items-center">
//           <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-500">
//             <MdOutlineSearch size={20} />
//           </span>
//           <input
//             type="text"
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//             placeholder="Search by Name, Mobile, or Message..."
//             enterKeyHint="search"
//             className="pl-10 pr-4 py-2 w-full border border-gray-300 rounded outline-primaryColor placeholder:font-medium"
//           />
//           {searchQuery.length > 0 && (
//             <button
//               type="button"
//               onClick={() => setSearchQuery("")}
//               className="absolute right-3 text-gray-500 hover:text-red-500 transition-colors duration-150"
//               title="Clear"
//             >
//               &#x2715;
//             </button>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// ------------------  Skeleton Loader ------------------
const VolunteerSkeletonLoader = () => {
  return (
    <div className="overflow-x-auto animate-pulse">
      <table className="min-w-full divide-y divide-gray-200 border rounded-lg">
        <thead className="bg-gray-50">
          <tr>
            {[
              "SL No",
              "Name",
              "Contact Info",
              "WhatsApp",
              "Org/Designation",
              "Specialization",
              "Achievement",
              "Action",
              "Delete",
            ].map((col, idx) => (
              <th
                key={idx}
                className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
              >
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {Array.from({ length: 6 }).map((_, idx) => (
            <tr key={idx} className="bg-white">
              {Array.from({ length: 9 }).map((__, i) => (
                <td
                  key={i}
                  className="px-4 py-3 h-10 bg-gray-200 rounded-lg mb-2"
                ></td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// ------------------ Volunteer Detail Modal ------------------
const VolunteerDetailModal = ({ isOpen, onClose, volunteer }) => {
  if (!isOpen || !volunteer) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-800">
            Volunteer Request Details
          </h2>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-100 rounded-full transition-colors duration-200"
          >
            ✕
          </button>
        </div>
        <div className="p-6 space-y-4">
          <div className="flex items-center text-gray-700">
            <FiUser className="mr-3 text-primaryColor" /> 
            <div>
              <p className="text-xs text-gray-500 uppercase font-bold">Full Name</p>
              <p>{volunteer.fullName}</p>
            </div>
          </div>
          <div className="flex items-center text-gray-700">
            <FiMail className="mr-3 text-primaryColor" />
            <div>
              <p className="text-xs text-gray-500 uppercase font-bold">Email</p>
              <p className="break-all">{volunteer.email}</p>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="flex items-center text-gray-700">
              <FiPhone className="mr-3 text-primaryColor" />
              <div>
                <p className="text-xs text-gray-500 uppercase font-bold">Mobile</p>
                <p>{volunteer.mobile}</p>
              </div>
            </div>
            <div className="flex items-center text-gray-700">
              <FaWhatsapp className="mr-3 text-green-500" />
              <div>
                <p className="text-xs text-gray-500 uppercase font-bold">WhatsApp</p>
                <p>{volunteer.whatsappNumber}</p>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="flex items-center text-gray-700">
              <FiBriefcase className="mr-3 text-primaryColor" />
              <div>
                <p className="text-xs text-gray-500 uppercase font-bold">Designation</p>
                <p>{volunteer.designation}</p>
              </div>
            </div>
            <div className="flex items-center text-gray-700">
              <FiTarget className="mr-3 text-primaryColor" />
              <div>
                <p className="text-xs text-gray-500 uppercase font-bold">Organisation</p>
                <p>{volunteer.organisationName}</p>
              </div>
            </div>
          </div>
          
          <div className="border-t pt-4">
            <p className="text-xs text-gray-500 uppercase font-bold mb-1">Brief Profile</p>
            <p className="text-gray-700 text-sm whitespace-pre-wrap">{volunteer.briefProfile}</p>
          </div>

          <div>
            <p className="text-xs text-gray-500 uppercase font-bold mb-1 flex items-center gap-1">
              <FiLayers className="text-primaryColor" /> Specialization
            </p>
            <div className="flex flex-wrap gap-2 mt-1">
              {volunteer.specializationFields?.map((s, i) => (
                <span key={i} className="px-2 py-1 bg-blue-50 text-blue-600 rounded text-xs font-medium">
                  {s}
                </span>
              ))}
            </div>
          </div>

          {volunteer.pastAchievement && (
            <div className="border-t pt-4">
              <p className="text-xs text-gray-500 uppercase font-bold mb-1 flex items-center gap-1">
                <FiAward className="text-yellow-600" /> Past Achievement
              </p>
              <p className="text-gray-700 text-sm whitespace-pre-wrap">{volunteer.pastAchievement}</p>
            </div>
          )}

          {volunteer.pastAchievementPhoto && (
            <div className="mt-2 text-center">
              <img 
                src={volunteer.pastAchievementPhoto} 
                alt="Achievement" 
                className="w-full h-auto rounded-lg border shadow-sm max-h-48 object-cover"
              />
            </div>
          )}

          <div className="border-t pt-4 flex items-start text-gray-700">
            <FiMessageSquare className="mr-3 mt-1 text-primaryColor" />
            <div>
              <p className="text-xs text-gray-500 uppercase font-bold">Message</p>
              <p className="text-sm whitespace-pre-wrap">{volunteer.message}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// ------------------ Main AdminVolunteers Component ------------------
const AdminVolunteers = () => {
  const ITEMS_PER_PAGE = 6;
  const [allVolunteers, setAllVolunteers] = useState([]);
  const [filteredVolunteers, setFilteredVolunteers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [error, setError] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [selectedVolunteer, setSelectedVolunteer] = useState(null);

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const getVolunteers = async () => {
    try {
      const resp = await axiosInstance.get("/volunteer");
      setAllVolunteers(resp.data);
      setFilteredVolunteers(resp.data);
      setError(false);
    } catch (err) {
      console.error(err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getVolunteers();
  }, []);

  const onSearchHandler = (query) => {
    setSearchTerm(query);
    const lowerCaseQuery = query.trim().toLowerCase();
    const results = allVolunteers.filter(
      (v) =>
        v.fullName.toLowerCase().includes(lowerCaseQuery) ||
        v.mobile.toLowerCase().includes(lowerCaseQuery) ||
        (v.email || "").toLowerCase().includes(lowerCaseQuery) ||
        (v.whatsappNumber || "").toLowerCase().includes(lowerCaseQuery) ||
        (v.organisationName || "").toLowerCase().includes(lowerCaseQuery) ||
        (v.designation || "").toLowerCase().includes(lowerCaseQuery) ||
        (v.specializationFields || []).some(s => s.toLowerCase().includes(lowerCaseQuery))
    );
    setFilteredVolunteers(results);
    setCurrentPage(1);
  };

  const handleDelete = async () => {
    if (!deletingId) return;
    try {
      setIsDeleting(true);
      await axiosInstance.delete(`/volunteer/${deletingId}`);
      toast.success("Volunteer request deleted");
      getVolunteers();
    } catch (err) {
      console.error("Error deleting volunteer", err);
      toast.error("Delete failed");
    } finally {
      setIsDeleting(false);
      setIsDeleteModalOpen(false);
      setDeletingId(null);
    }
  };

  const totalPages = Math.ceil(filteredVolunteers.length / ITEMS_PER_PAGE);
  const paginatedVolunteers = filteredVolunteers.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const truncateText = (text, limit = 20) =>
    text.length > limit ? text.slice(0, limit) + "..." : text;

  return (
    <div>
      <AdminSearchBar
        title="All Volunteer Requests"
        hideAddButton={true}
        onSearchClick={onSearchHandler}
      />

      <div className="py-6 px-4 md:px-8 overflow-x-auto">
        {loading ? (
          <VolunteerSkeletonLoader />
        ) : error ? (
          <div className="w-full text-center py-16">
            <div className="inline-block bg-red-100 border border-red-300 text-red-700 px-6 py-4 rounded-lg shadow-md">
              <p className="text-lg font-semibold">
                Oops! Something went wrong.
              </p>
              <p className="mt-1 text-sm">
                We couldn't fetch volunteer requests. Please try again later.
              </p>
            </div>
          </div>
        ) : filteredVolunteers.length === 0 ? (
          <div className="w-full text-center py-10 text-gray-600 text-lg font-medium">
            No volunteer requests found.
          </div>
        ) : (
          <table className="min-w-full divide-y divide-gray-200 border rounded-lg">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  SL No
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Name
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Contact Info
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  WhatsApp
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Org/Designation
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Specialization
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Achievement
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Action
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Delete
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {paginatedVolunteers.map((v, idx) => (
                <tr key={v._id} className="hover:bg-gray-50 transition-colors">
                  <td className="px-4 py-2">
                    {(currentPage - 1) * ITEMS_PER_PAGE + idx + 1}
                  </td>
                  <td className="px-4 py-2">
                    <div className="font-medium text-gray-900">{truncateText(v.fullName, 15)}</div>
                  </td>
                  <td className="px-4 py-2">
                    <div className="text-xs text-gray-600 break-all">{v.email}</div>
                    <div className="text-xs text-blue-600 font-medium">{v.mobile}</div>
                  </td>
                  <td className="px-4 py-2 text-xs text-green-600 font-medium">
                    {v.whatsappNumber || "N/A"}
                  </td>
                  <td className="px-4 py-2">
                    <div className="text-xs font-medium text-gray-800">{truncateText(v.organisationName || "N/A", 15)}</div>
                    <div className="text-[10px] text-gray-500 italic">{truncateText(v.designation || "N/A", 15)}</div>
                  </td>
                  <td className="px-4 py-2">
                    <div className="flex flex-wrap gap-1">
                      {v.specializationFields?.slice(0, 2).map((s, i) => (
                        <span key={i} className="px-1.5 py-0.5 bg-gray-100 text-gray-600 rounded-[4px] text-[10px] whitespace-nowrap">
                          {s}
                        </span>
                      ))}
                      {v.specializationFields?.length > 2 && (
                        <span className="text-[10px] text-gray-400">+{v.specializationFields.length - 2}</span>
                      )}
                    </div>
                  </td>
                  <td className="px-4 py-2">
                    <div className="flex items-center gap-1.5">
                      <div className="text-[11px] text-gray-600 line-clamp-1">
                        {v.pastAchievement ? truncateText(v.pastAchievement, 15) : "None"}
                      </div>
                      {v.pastAchievementPhoto && (
                        <FiAward className="text-yellow-600 size-3 shrink-0" title="Has Photo" />
                      )}
                    </div>
                  </td>
                  <td className="px-4 py-2">
                    <button
                      onClick={() => {
                        setSelectedVolunteer(v);
                        setIsDetailModalOpen(true);
                      }}
                      className="px-3 py-1 bg-blue-600 text-white rounded text-sm hover:bg-blue-700"
                    >
                      View Details
                    </button>
                  </td>
                  <td className="px-4 py-2">
                    <button
                      onClick={() => {
                        setDeletingId(v._id);
                        setIsDeleteModalOpen(true);
                      }}
                      className="flex items-center text-red-600 hover:text-red-800 text-sm font-medium"
                    >
                      <MdDeleteOutline className="mr-1 size-5" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Pagination */}
      <Pagination
        currentPage={currentPage}
        onPageChange={setCurrentPage}
        totalPages={totalPages}
      />

      {/* Detail Modal */}
      <VolunteerDetailModal
        isOpen={isDetailModalOpen}
        onClose={() => setIsDetailModalOpen(false)}
        volunteer={selectedVolunteer}
      />

      {/* Delete Modal */}
      <DeleteConfirmationModal
        isOpen={isDeleteModalOpen}
        onConfirm={handleDelete}
        onClose={() => setIsDeleteModalOpen(false)}
        loading={isDeleting}
        itemName="this volunteer request"
      />
    </div>
  );
};

export default AdminVolunteers;
